import { useMemo } from 'react'
import { CustomTable, TableEmptyState } from 'app/components'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { LogAtendimentoView } from '../core/_models'
import { LogsConsultaIdColumns } from './columns/_columns'
import { useT } from '_metronic/i18n/Metronici18n'

export const LogsConsultaIdTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { t } = useT()

  const columns = useMemo(() => LogsConsultaIdColumns(t), [t])

  return (
    <CustomTable<LogAtendimentoView>
      id='kt_table_consulta_id'
      ariaLabel='Logs do atendimento'
      itemLabel={{ singular: 'registro', plural: 'registros' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={
        <TableEmptyState
          title='Nenhum registro para este atendimento'
          description='As ações feitas no atendimento aparecem aqui.'
        />
      }
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
